import { IContent } from '../types/IContent';
import { IGetItemsParams } from '../types/IGetItemsParams';
import { IGetItemsResult } from '../types/IGetItemsResult';
import { IUser } from '../types/IUser';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface IGetContentForUserResult extends IGetItemsResult {
  content: IContent[];
  users: IUser[];
}

export class GetContentForUserRequest extends Request<IGetItemsParams, IGetContentForUserResult> {
  constructor(params: IGetItemsParams) {
    super('getContentForUser', params);
  }
}
